// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { NavLink } from 'react-router-dom';
import { withRouter } from '../../utils/routerCompat';
import { eventNames } from "../../constants/eventNames";
import { PubSub } from "pubsub-js";
import { AuthService } from "../../services/auth.service";
import { toast } from "react-toastify";
import { LoaderService } from "../../services/loader.service";
import $ from "jquery";
import { getComponentMode, getValidationMode } from "../../utils/sync";
import ApiService from "../../services/api.service";

import like from "./../../assets/images/like.svg?url";
import likeRed from "./../../assets/images/like-red.svg?url";
import playLightRed from "./../../assets/images/play_light_red.svg?url";
import playLight from "./../../assets/images/play-light.svg?url";
import likeLight from "./../../assets/images/like-light.svg?url";
import albumsLight from "./../../assets/images/albums-light.svg?url";
import logoutLight from "./../../assets/images/logout-light.svg?url";

import stepExecutionIcon from "../../assets/images/step_execution.svg?url";
import ThemeSwitcher from "../theme/ThemeSwitcher";

class ActionNav extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      assert: getValidationMode(),
      isCapturingAbsolutePath: false,
      flowData: {},
      devMode: getComponentMode() === "dev",
      userMode: getComponentMode() !== "dev",
      showFlowGroupBtn: false,
      breakpointActivities: [],
      showActivityDebugOptions: false,
      showRunMenu: false
    };
    this.runMenuRef = React.createRef();
    this.api = ApiService.getInstance();
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleClickOutsideRunMenu = (e) => {
    if (this.runMenuRef.current && !this.runMenuRef.current.contains(e.target)) {
      this.setState({ showRunMenu: false });
    }
  };

  componentDidMount() {
    this._isMounted = true;
    document.addEventListener('mousedown', this.handleClickOutsideRunMenu);
    this.subscribeActivityDebug = PubSub.subscribe("UPDATE_ACTVITY_DEBUG", (msg, data) => {
      if (this._isMounted) {
        this.setState({
          showActivityDebugOptions: data
        });
      }
    });
    this.taskRunningFinished = PubSub.subscribe("TASK_RUNNING_FINISHED", this.onTaskRunningFinished);
    this.breakPointCountChangeSubscription = PubSub.subscribe(
      eventNames.handleListenBreakpointChange,
      (msg, data) => {
        // The data passed directly from TableRowItem/Table contains the activities
        // Filter activities that have showBreakpoint set to true
        // Data structure: array of activity arrays, where each activity array has activity objects
        // We need to check: activity[0].showBreakpoint === true
        let breakpointActivities = [];

        if (Array.isArray(data)) {
          // Check ALL activities in each group, not just [0]
          for (const actGroup of data) {
            if (!Array.isArray(actGroup)) continue;
            for (const act of actGroup) {
              if (act && act.showBreakpoint === true) {
                breakpointActivities.push(actGroup);
                break; // count each group once
              }
              // Also check child activities
              if (act && act.childActivity && Array.isArray(act.childActivity)) {
                const hasChildBreakpoint = act.childActivity.some(c => c && c.showBreakpoint === true);
                if (hasChildBreakpoint) {
                  breakpointActivities.push(actGroup);
                  break;
                }
              }
            }
          }
        }

        if (this._isMounted) {
          this.setState({
            breakpointActivities: breakpointActivities
          });
        }
      }
    );
    this.treeUpdatesSubscription = PubSub.subscribe(eventNames.treeUpdated, this.treeUpdatesSubscriber);
    this.subscriberFlowData = PubSub.subscribe(eventNames.flowData, this.subscriberFlowDataHandler);
    this.subscribeAssertColor = PubSub.subscribe(eventNames.assertColor, (msg, assert) => this.setState({ assert }));
    this.subscribeIsCapturingAbsoltePath = PubSub.subscribe(
      eventNames.isCapturingAbsolutePath,
      (msg, isCapturingAbsolutePath) => this.setState({ isCapturingAbsolutePath })
    );
    this.componentTestResultSavedSubscription = PubSub.subscribe(eventNames.componentTestResultSaved, () => {});
    this.subscribeComponentModeUiUpdate = PubSub.subscribe(eventNames.componentModeUiUpdate, (msg, data) => {
      if (data.mode && data.mode === "dev" && this.state.devMode) return;
      if (this.state.devMode && data.mode && data.mode !== "dev") {
        if (this._isMounted) {
          this.setState({
            devMode: false,
            userMode: true,
            assert: false
          });
        }
      } else if (this.state.userMode && data.mode && data.mode !== "user") {
        if (this._isMounted) {
          this.setState({
            devMode: true,
            userMode: false
          });
        }
      }
    });

    this.changePath = PubSub.subscribe(eventNames.changePath, (msg, data) => {
      // 🔍 Debug: Log changePath message received
      console.log('🔍🔍🔍 [ActionNav] changePath received:', {
        path: data.path,
        msg,
        timestamp: new Date().toISOString()
      });

      let item = localStorage.getItem("default_ext_values");
      if (!item) {
        console.warn('🔍🔍🔍 [ActionNav] changePath - default_ext_values not found in localStorage!');
        return;
      }
      item = JSON.parse(item);
      const oldPath = item["capturePath"];
      item["capturePath"] = data.path;
      localStorage.setItem("default_ext_values", JSON.stringify(item));

      // 🔍 Debug: Log after update
      console.log('🔍🔍🔍 [ActionNav] changePath updated localStorage:', {
        oldPath,
        newPath: data.path,
        updatedItem: item
      });

      if (this._isMounted) {
        this.setState({
          isCapturingAbsolutePath: data.path === "absolute"
        });
      }
    });
    this.subscribeValidationModeUiUpdate = PubSub.subscribe(eventNames.validationModeUiUpdate, (msg, data) => {
      if (data.validation !== undefined) {
        if (this._isMounted) {
          this.setState({
            assert: data.validation
          });
        }
      }
    });

    if (getComponentMode() === "dev") {
      if (this._isMounted) {
        this.setState({
          devMode: true,
          userMode: false
        });
      }
    } else {
      if (this._isMounted) {
        this.setState({
          devMode: false,
          userMode: true
        });
      }
    }
  }

  checkFlows = data => {
    for (let i of data) {
      const temp = i.children.find(obj => obj.name === "Flows");
      if (
        temp !== undefined &&
        temp !== null &&
        temp.children !== undefined &&
        temp.children !== null &&
        temp.children.length > 0
      )
        return true;
    }
    return false;
  };
  onTaskRunningFinished = () => {
    this.setState({ isTaskRunning: false });
  };
  treeUpdatesSubscriber = (msg, data) => {
    if (this._isMounted) {
      if (this.checkFlows(data)) this.setState({ showFlowGroupBtn: true });
      else this.setState({ showFlowGroupBtn: false });
    }
  };

  subscriberFlowDataHandler = (msg, data) => {
    if (this._isMounted) {
      this.setState({
        flowData: data
      });
    }
  };

  displayLogin() {
    if (AuthService.token) {
      return (
        <li>
          <a href="#" onClick={this.handleLogout} className="ico ico-login" title={AuthService.user.username}></a>
        </li>
      );
    }
  }

  handleLogout() {
    try {
      this.api.signout("/apis/auth/signout", {}).then(() => {
        AuthService.globalLogout();
      });
      localStorage.removeItem("checkedList");
    } catch (error) {
      if (this._isMounted) {
        this.setState({
          error: "Something went wrong. Please try again."
        });
      }
    }

    var ele = $("#msgBox");

    ele = $("#msgBoxErr");
    setTimeout(function() {
      ele.hide();
    }, 4000);
  }

  debugRunnerEvent = (executionMode) => {
    // Auto-upgrade to DEBUG mode if breakpoints are set and user clicked Run
    const hasBreakpoints = this.state.breakpointActivities && this.state.breakpointActivities.length > 0;
    const effectiveMode = (executionMode === 'INTERACTIVE' && hasBreakpoints) ? 'DEBUG' : (executionMode || 'INTERACTIVE');
    if (executionMode === 'INTERACTIVE' && hasBreakpoints) {
      console.log('[ActionNav] Auto-upgrading to DEBUG mode — breakpoints detected:', this.state.breakpointActivities.length);
    }
    this.setState({
      isTaskRunning: true,
      showRunMenu: false
    });
    PubSub.publish(eventNames.runAgentScript, { executionMode: effectiveMode });
  };

  toggleRunMenu = () => {
    this.setState(prev => ({ showRunMenu: !prev.showRunMenu }));
  };

  async handleFileInputChange(e) {
    const selectedFile = e.target.files[0];
    const allowedFiles = ["zip", "rar", "gz", "7z", "xz"];
    if (!allowedFiles.includes(selectedFile.name.split(".").reverse()[0])) {
      return toast.error("You can select archive file only!");
    }

    const formData = new FormData();
    formData.append("name", selectedFile.name);
    formData.append("file", selectedFile);

    LoaderService.show();
    const apiService = ApiService.getInstance();
    const response = await apiService.post(`/web-sites`, formData);

    const id = this.props.location.pathname.split("/").reverse()[0];
    if (response.success) {
      await apiService.put(`/components/${id}`, {
        url: `${process.env.REACT_APP_SERVER_URL}/${response.payload.url}`
      });
      LoaderService.hide();
      if (response.success) {
        PubSub.publish(eventNames.iframeLoad, `${process.env.REACT_APP_SERVER_URL}/${response.payload.url}`);
        toast.success(`File ${response.payload.name} successfully uploaded!`);
      } else {
        toast.error(response.error.description);
      }
    } else {
      LoaderService.hide();
      toast.error(response.error.description);
    }
  }

  render() {
    const locationProps = this.props.match;
    const url = locationProps.url.split("/")[1];
    const urlId = locationProps.url.split("/")[2];
    const id = locationProps.params.id;
    const { showFlowGroupBtn } = this.state;
    const href = window.location.href;
    const isFlowPage = url === "work-flows";

    function shouldRenderBreakPoint(breakpointActivities) {
      return breakpointActivities.length >= 1;
    }

    function shouldRenderStepExecution(breakpointActivities) {
      return breakpointActivities.length >= 1;
    }

    // Debug logging
    console.log('🔍 ActionNav render:', {
      isFlowPage,
      showActivityDebugOptions: this.state.showActivityDebugOptions,
      breakpointActivities: this.state.breakpointActivities,
      breakpointCount: this.state.breakpointActivities.length
    });

    return (
      <div className="canvas-icons-menu action-nav-button-input">
        <ul>
          {/* Run All button - shows on Flow page when Activity panel visible and breakpoints are set */}
          {isFlowPage &&
            this.state.showActivityDebugOptions &&
            shouldRenderBreakPoint(this.state.breakpointActivities) && (
              <li
                className="clickable"
                onClick={() => {
                  PubSub.publish(eventNames.debugRunAll);
                }}
                title="Run All - Continue execution to next breakpoint"
              >
                <i className="fas fa-play" style={{ color: '#4CAF50', fontSize: '18px' }}></i>
              </li>
            )}
          {/* Step by Step Debug button - shows on Flow page when Activity panel visible and breakpoints are set */}
          {isFlowPage &&
            this.state.showActivityDebugOptions &&
            shouldRenderStepExecution(this.state.breakpointActivities) && (
              <li
                className="clickable"
                onClick={() => {
                  PubSub.publish(eventNames.debugStepRun);
                }}
                title="Step by Step Debug - Execute one activity at a time"
              >
                <img src={stepExecutionIcon} width="24px" height="24px" alt="Step Execution" style={{ filter: 'brightness(1.2)' }} />
              </li>
            )}
          {(url === "api" || url === "work-flows" || url === "graphql-api") && urlId === id && (
            <li className="execute-btn run-btn-container" ref={this.runMenuRef}>
              <span className="run-btn-main" onClick={this.toggleRunMenu} title="Click to choose Run or Debug">
                <img src={playLight} alt="Run" />
              </span>
              <span className="run-btn-caret" onClick={this.toggleRunMenu} title="Run options">
                <i className="fas fa-caret-down" style={{ fontSize: '10px' }} />
              </span>
              {this.state.showRunMenu && (
                <ul className="run-dropdown-menu">
                  <li onClick={() => this.debugRunnerEvent('INTERACTIVE')}>
                    <i className="fas fa-play" style={{ color: '#52ea58', marginRight: 8 }} />
                    Run
                  </li>
                  <li onClick={() => this.debugRunnerEvent('DEBUG')}>
                    <i className="fas fa-bug" style={{ color: '#f59e0b', marginRight: 8 }} />
                    Run as Debug
                  </li>
                </ul>
              )}
            </li>
          )}
          {url === "components" && urlId && urlId === id && (
            <React.Fragment>
              {/* Timer icon removed - Timer functionality moved to Activity dropdown (Timer > Wait option) */}
              <li
                style={{ display: "none" }}
                className="clickable"
                onClick={() => PubSub.publish(eventNames.handleAssertToggle)}
              >
                {/*<i
                  className="ico ico-like assertColor"
                  style={{ color: this.state.assert ? "red" : "#647386" }}
                ></i>*/}
                <img
                  src={
                    this.state.assert
                      ? likeRed
                      : document.body.className && document.body.classList.contains("light")
                      ? likeLight
                      : like
                  }
                  title="Assert"
                  alt="Assert"
                />
              </li>
              {/* JS Icon removed as per user request - JS scripts can still be dragged from left sidebar */}
            </React.Fragment>
          )}
          {showFlowGroupBtn &&
            (href.includes("/components") ||
              href.includes("/uservariables") ||
              href.includes("/scripts") ||
              href.includes("/work-connections") ||
              href.includes("/work-flows") ||
              href.includes("/flow-groups")) && (
              <li>
                <NavLink to="/flow-groups" title="FlowGroups">
                  <img src={albumsLight} title="FlowGroups" alt="FlowGroups" />
                </NavLink>
              </li>
            )}
          {/*<li className="clickable">
            <img src={document.body.className && document.body.classList.contains("light") ? questionLight : question} />
            <i className="fas fa-question-circle"></i>
          </li>*/}
          {/*<li className="clickable">
            <img src={document.body.className && document.body.classList.contains("light") ? bellLight : bell} />
            <i className="fas fa-bell"></i>
            <span className="badge-notify">2</span>
          </li>*/}
          {/*<li className="clickable">
            <a className="signIn">
              <img src={lock} />
              <span>Sign In</span>
            </a>
          </li>*/}
          {/*<li className="clickable">
            <button className="sign-in-btn">
              <i className="fas fa-user-lock"></i> Sign In
            </button>
          </li>*/}
          <ThemeSwitcher />
          <li className="clickable" onClick={this.handleLogout}>
            {/*<img
              src="https://via.placeholder.com/40"
              className="ico ico-login"
              title={AuthService.user.username}
            />*/}
            <img src={logoutLight} title="Logout" alt="Logout" />
            {/*<a href="#" onClick={this.handleLogout} className="ico ico-login" title={AuthService.user.username}></a>*/}
          </li>

          {/*{this.displayLogin()}*/}
        </ul>
      </div>
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener('mousedown', this.handleClickOutsideRunMenu);
    this.breakPointCountChangeSubscription && PubSub.unsubscribe(this.breakPointCountChangeSubscription);
    this.subscribeActivityDebug && PubSub.unsubscribe(this.subscribeActivityDebug);
    this.subscriberFlowData && PubSub.unsubscribe(this.subscriberFlowData);
    this.subscribeAssertColor && PubSub.unsubscribe(this.subscribeAssertColor);
    this.subscribeIsCapturingAbsoltePath && PubSub.unsubscribe(this.subscribeIsCapturingAbsoltePath);
    this.subscribeValidationModeUiUpdate && PubSub.unsubscribe(this.subscribeValidationModeUiUpdate);
    this.subscribeComponentModeUiUpdate && PubSub.unsubscribe(this.subscribeComponentModeUiUpdate);
    this.treeUpdatesSubscription && PubSub.unsubscribe(this.treeUpdatesSubscription);
    this.taskRunningFinished && PubSub.unsubscribe(this.OnTaskRunningFinished);
    this.componentTestResultSavedSubscription && PubSub.unsubscribe(this.componentTestResultSavedSubscription);
  }
}

export default withRouter(ActionNav);
